import React from 'react';
import PropTypes from 'prop-types';

import basketIcon from 'assets/basket.svg';
import CTA from 'components/CTA';

import styles from '../../../pop-up.module.scss';

const Step3 = ({ setRerender, setShowModal }) => {
  return (
    <div className={styles.content}>
      <h1 className={styles.title}>Registro Exitoso</h1>
      <h2 className={styles.subtitle}>
        ¡Se ha añadido exitosamente un nuevo proveedor a tu lista!
      </h2>
      <img className={styles.icon} src={basketIcon} alt="basket" />
      <div className={styles.bottomContainer}>
        <CTA
          text="Ver Mis Proveedores"
          onClick={() => {
            setShowModal(false);
            setRerender(true);
          }}
        />
      </div>
    </div>
  );
};

Step3.propTypes = {
  setRerender: PropTypes.func.isRequired,
  setShowModal: PropTypes.func.isRequired,
};

export default Step3;
